import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnapShotService } from '../services/snap-shot.service';
import { RendererService } from '../services/renderer.service';
import { ProjectManagerService } from '../services/project-manager.service';
import { NgForm } from '@angular/forms';
import { ProToolsUiManagerService } from '../services/pro-tools-ui-manager.service';

@Component({
  selector: 'app-modal-save-image',
  templateUrl: './modal-save-image.component.html',
  styleUrls: ['./modal-save-image.component.scss']
})
export class ModalSaveImageComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ModalSaveImageComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snapShotService: SnapShotService,
    private rendererSrvc: RendererService,
    private projectSrvc: ProjectManagerService,
    private proToolsManager: ProToolsUiManagerService
  ) {
    this.projectSrvc.isSavedProject.subscribe(value => this.isSavedProject = value);
   }

   isSavedProject: boolean = false;
   imgName: string;
   projectName: string;
   imgNotes: string;
   imgUrl: string;
   snapshotsProTools = [];

  onSubmit(f: NgForm) {
    let snapshot = this.rendererSrvc.getScreenShot();
    let saveImgData:object = {};
    saveImgData["imgName"] = this.imgName;
    saveImgData["projectName"] = this.projectName;
    saveImgData["imgNotes"] = this.imgNotes;
    saveImgData["imgUrl"] = snapshot;
    this.snapShotService.pushSnapshotsProTools(saveImgData);
    let snapshotsProTools = this.snapShotService.getSnapshotsProTools();
    // console.log(saveImgData);
    if (this.isSavedProject) {
      let projectId = this.projectSrvc.getCurrentProjectId();
      this.projectSrvc.updateProjectItem(projectId, "snapshotsProTools", snapshotsProTools).subscribe(res => {
        // console.log(res);
        this.snapShotService.setSnapshotsProTools(res.snapshotsProTools) });
    }
    // console.log(this.snapShotService.snapshotsProTools);
  }

  ngOnInit() {
  }

  save() {
    this.proToolsManager.saved = true;
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/modal-save-image/modal-save-image.component.ts